import { ADD_DESCRIPTIVE_ROW_ITEMS_TO_WIDGET, ADD_HORIZONTAL_ITEMS_TO_WIDGET, ADD_VERTICAL_ITEMS_TO_WIDGET, ADD_VISUAL_ROW_ITEMS_TO_WIDGET, ADD_WIDGETS_TO_TEMPLATE, BIND_TEMPLATE, CREATE_AND_BIND_TEMPLATE, CREATE_TEMPLATE, INVALIDATE_TEMPLATE, REMOVE_ROW_ITEM_FROM_WIDGET, REMOVE_TEMPLATE, REORDER_TRACK, TEMPLATE_RENDERED, URL_CHANGE, } from '../actions';
import { CLEAR, PLAYBACK_NOT_SUPPORTED } from '../actions/Playback';
import { DIALOG_TEMPLATE } from '../types/templates/dialog';
import { FEEDBACK_DIALOG_TEMPLATE } from '../types/templates/feedbackDialog';
import { NOW_PLAYING_TEMPLATE } from '../types/templates/nowPlaying';
function array_move(arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
        let k = newIndex - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
}
;
const initialState = {
    currentTemplate: undefined,
    urlMap: {},
    overlayTemplates: [],
    coldStart: true,
};
export function TemplateStackReducer(state = initialState, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    switch (action.type) {
        case TEMPLATE_RENDERED:
            if (!((_a = action.payload.template.id) === null || _a === void 0 ? void 0 : _a.includes('ChromeTemplate')) && state.coldStart) {
                return Object.assign(Object.assign({}, state), { coldStart: false });
            }
            return state;
        case CREATE_TEMPLATE:
        case CREATE_AND_BIND_TEMPLATE:
            if (isOverlayTemplate(action.payload.template)) {
                return createOverlayTemplate(state, action.payload.template);
            }
            else if (action.payload.screenMode === 'templateShard') {
                return replaceInnerTemplate(state, action.payload.template);
            }
            else {
                return updateCurrentTemplate(state, action.payload.template);
            }
        case BIND_TEMPLATE:
            if (isOverlayTemplate(action.payload.template)) {
                return updateOverlayTemplate(state, action.payload.template, action.payload.owner);
            }
            else if (((_b = state.currentTemplate) === null || _b === void 0 ? void 0 : _b.id) === action.payload.owner) {
                return updateCurrentTemplate(state, action.payload.template);
            }
            else if (action.payload.owner === ((_d = (_c = state.currentTemplate) === null || _c === void 0 ? void 0 : _c.innerTemplate) === null || _d === void 0 ? void 0 : _d.id)) {
                return updateInnerTemplate(state, action.payload.template);
            }
            else {
                // update unrendered template
                return Object.assign(Object.assign({}, state), { urlMap: updateUrlMap(state.urlMap, action.payload.template) });
            }
        case REMOVE_TEMPLATE:
            if (state.overlayTemplates.length) {
                return Object.assign(Object.assign({}, state), { overlayTemplates: state.overlayTemplates.filter((template) => template.id !== action.payload.owner) });
            }
            else {
                return state;
            }
        case URL_CHANGE:
            // Prevent store from pushing same template twice in case we get a URL_CHANGE
            // incorrectly for the same URL that we are currently on.
            // Please see https://sim.amazon.com/issues/DMWebPlayer-19205 for details
            const currentDeeplink = ((_h = (_g = (_f = (_e = state) === null || _e === void 0 ? void 0 : _e.currentTemplate) === null || _f === void 0 ? void 0 : _f.innerTemplate) === null || _g === void 0 ? void 0 : _g.templateData) === null || _h === void 0 ? void 0 : _h.deeplink) || ((_l = (_k = (_j = state) === null || _j === void 0 ? void 0 : _j.currentTemplate) === null || _k === void 0 ? void 0 : _k.templateData) === null || _l === void 0 ? void 0 : _l.deeplink);
            if (action.payload.newUrl === currentDeeplink) {
                return state;
            }
            const newTemplate = state.urlMap[action.payload.newUrl];
            return replaceInnerTemplate(state, newTemplate);
        case INVALIDATE_TEMPLATE:
            const invalidatedAt = Date.now();
            const urls = {};
            for (const key in state.urlMap) {
                if (state.urlMap.hasOwnProperty(key)) {
                    const template = state.urlMap[key];
                    urls[key] = Object.assign(Object.assign({}, template), { invalidatedAt });
                }
            }
            return Object.assign(Object.assign(Object.assign({}, state), { overlayTemplates: [] }), { urlMap: urls });
        case PLAYBACK_NOT_SUPPORTED:
        case CLEAR:
            return Object.assign(Object.assign({}, state), { overlayTemplates: state.overlayTemplates.filter((template) => template.interface !== NOW_PLAYING_TEMPLATE) });
        case ADD_WIDGETS_TO_TEMPLATE:
            if ((_o = (_m = state) === null || _m === void 0 ? void 0 : _m.currentTemplate) === null || _o === void 0 ? void 0 : _o.innerTemplate) {
                // @ts-ignore
                const templateWidgets = [...(((_r = (_q = (_p = state) === null || _p === void 0 ? void 0 : _p.currentTemplate) === null || _q === void 0 ? void 0 : _q.innerTemplate) === null || _r === void 0 ? void 0 : _r.widgets) || []), ...action.payload.items];
                const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
                    innerTemplate: Object.assign(Object.assign(Object.assign({}, state.currentTemplate.innerTemplate), { widgets: templateWidgets }), { onEndOfWidgetsReached: action.payload.onEndOfWidget }),
                });
                return Object.assign(Object.assign({}, state), { currentTemplate });
            }
            else {
                return state;
            }
        case ADD_VISUAL_ROW_ITEMS_TO_WIDGET:
        case ADD_DESCRIPTIVE_ROW_ITEMS_TO_WIDGET:
        case ADD_VERTICAL_ITEMS_TO_WIDGET:
        case ADD_HORIZONTAL_ITEMS_TO_WIDGET:
            if ((_t = (_s = state) === null || _s === void 0 ? void 0 : _s.currentTemplate) === null || _t === void 0 ? void 0 : _t.innerTemplate) {
                // @ts-ignore
                const templateWidgets = (_w = (_v = (_u = state) === null || _u === void 0 ? void 0 : _u.currentTemplate) === null || _v === void 0 ? void 0 : _v.innerTemplate) === null || _w === void 0 ? void 0 : _w.widgets;
                const widgetToUpdate = Object.assign({}, templateWidgets[0]);
                widgetToUpdate.items = widgetToUpdate.items.concat(action.payload.items);
                widgetToUpdate.onEndOfWidget = action.payload.onEndOfWidget;
                const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
                    innerTemplate: Object.assign(Object.assign({}, state.currentTemplate.innerTemplate), {
                        widgets: [widgetToUpdate, ...templateWidgets.slice(1)],
                    }),
                });
                return Object.assign(Object.assign({}, state), { currentTemplate });
            }
            else {
                return state;
            }
        case REORDER_TRACK:
            if ((_y = (_x = state) === null || _x === void 0 ? void 0 : _x.currentTemplate) === null || _y === void 0 ? void 0 : _y.innerTemplate) {
                // @ts-ignore
                const templateWidgets = (_1 = (_0 = (_z = state) === null || _z === void 0 ? void 0 : _z.currentTemplate) === null || _0 === void 0 ? void 0 : _0.innerTemplate) === null || _1 === void 0 ? void 0 : _1.widgets;
                const widgetToUpdate = Object.assign({}, templateWidgets[0]);
                const items = [...widgetToUpdate.items];
                array_move(items, action.payload.trackIndex, action.payload.moveToIndex);
                widgetToUpdate.items = items;
                const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
                    innerTemplate: Object.assign(Object.assign({}, state.currentTemplate.innerTemplate), {
                        widgets: [widgetToUpdate, ...templateWidgets.slice(1)],
                    }),
                });
                return Object.assign(Object.assign({}, state), { currentTemplate });
            }
            else {
                return state;
            }
        case REMOVE_ROW_ITEM_FROM_WIDGET:
            if ((_3 = (_2 = state) === null || _2 === void 0 ? void 0 : _2.currentTemplate) === null || _3 === void 0 ? void 0 : _3.innerTemplate) {
                // @ts-ignore
                const templateWidgets = (_6 = (_5 = (_4 = state) === null || _4 === void 0 ? void 0 : _4.currentTemplate) === null || _5 === void 0 ? void 0 : _5.innerTemplate) === null || _6 === void 0 ? void 0 : _6.widgets;
                const widgetsToUpdate = [];
                for (const key in templateWidgets) {
                    if (templateWidgets.hasOwnProperty(key)) {
                        const templateWidget = templateWidgets[key];
                        const widgetUpdate = Object.assign(Object.assign({}, templateWidget), { items: templateWidget.items.filter((item) => item.id !== action.payload.id) });
                        widgetsToUpdate.push(widgetUpdate);
                    }
                }
                const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
                    innerTemplate: Object.assign(Object.assign({}, state.currentTemplate.innerTemplate), { widgets: widgetsToUpdate }),
                });
                return Object.assign(Object.assign({}, state), { currentTemplate });
            }
            else {
                return state;
            }
        default:
            return state;
    }
}
function updateCurrentTemplate(state, newTemplate) {
    const urlMap = updateUrlMap(state.urlMap, newTemplate);
    return Object.assign(Object.assign(Object.assign({}, state), { urlMap }), {
        currentTemplate: Object.assign(Object.assign({}, newTemplate), { updatedAt: Date.now() }),
    });
}
function updateInnerTemplate(state, newTemplate) {
    if (!state.currentTemplate) {
        return state;
    }
    const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
        innerTemplate: Object.assign(Object.assign(Object.assign({}, state.currentTemplate.innerTemplate), newTemplate), { updatedAt: Date.now() }),
    });
    const urlMap = updateUrlMap(state.urlMap, newTemplate);
    return Object.assign(Object.assign({}, state), { currentTemplate, urlMap });
}
function replaceInnerTemplate(state, newTemplate) {
    if (!state.currentTemplate) {
        return state;
    }
    const previousTemplate = Object.assign({}, state.currentTemplate);
    const currentTemplate = Object.assign(Object.assign({}, state.currentTemplate), {
        innerTemplate: Object.assign(Object.assign({}, newTemplate), { updatedAt: Date.now() }),
    });
    const urlMap = updateUrlMap(state.urlMap, newTemplate);
    return Object.assign(Object.assign({}, state), { currentTemplate, previousTemplate, urlMap });
}
function updateUrlMap(urlMap, template) {
    var _a;
    let newUrlMap = urlMap;
    if ((_a = template) === null || _a === void 0 ? void 0 : _a.templateData) {
        newUrlMap = Object.assign(Object.assign({}, newUrlMap), { [template.templateData.deeplink]: template });
    }
    return newUrlMap;
}
function isOverlayTemplate(template) {
    const overlayTemplates = [DIALOG_TEMPLATE, NOW_PLAYING_TEMPLATE, FEEDBACK_DIALOG_TEMPLATE];
    return overlayTemplates.includes(template.interface);
}
function createOverlayTemplate(state, newTemplate) {
    return Object.assign(Object.assign({}, state), { overlayTemplates: [newTemplate, ...state.overlayTemplates] });
}
function updateOverlayTemplate(state, newTemplate, templateId) {
    return Object.assign(Object.assign({}, state), { overlayTemplates: state.overlayTemplates.map((template) => {
            if (template.id === templateId) {
                return Object.assign(Object.assign({}, newTemplate), { updatedAt: Date.now() });
            }
            return template;
        }) });
}
